<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-navigation-drawer v-model="drawer" absolute temporary right width="400">
      <div
        class="my-3 px-4"
        style="
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          align-items: center;
          border-bottom: 1px solid #d1d5db;
        "
      >
        <div class="mb-2" style="grid-column: 1/5; text-align: left">
          <p class="mb-1 title font-weight-regular">
            Cumpleaños
            {{
              birthDate.allMonths.length === 0
                ? ''
                : birthDate.allMonths[getCurrentMonth()].name
            }}
          </p>
          <span class="mb-1 body-1 gray--text">
            {{ birthDate.totalStudents }} alumnos
          </span>
        </div>
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                :disabled="birthDate.students.length === 0"
                @click="downloadBirthDateXlsx"
              >
                <v-icon color="primary">download</v-icon>
              </v-btn>
            </template>
            Descargar Cumpleaños
          </v-tooltip>
        </div>
      </div>
      <div
        style="box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px"
        class="custom_input px-4 mb-2"
      >
        <v-layout row wrap>
          <v-flex xs12 sm6 lg8>
            <v-text-field
              :disabled="birthDate.isLoading"
              v-model="birthDate.search"
              prepend-inner-icon="search"
              label="Buscar"
              solo
              flat
              dense
              hide-details
              clearable
              @keyup.enter="getBirthDateStudents(false, true)"
              @click:clear="
                () => {
                  birthDate.search = ''
                  getBirthDateStudents(false, true)
                }
              "
            />
          </v-flex>
          <v-flex xs12 sm6 lg4>
            <v-select
              :disabled="birthDate.isLoading"
              v-model="birthDate.selectedMonths"
              :items="birthDate.allMonths"
              item-text="short"
              value="value"
              multiple
              persistent-hint
              outline
              solo
              flat
              dense
              hide-details
              @change="getBirthDateStudents(false, true)"
            >
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="
                    () => {
                      toggleMonths()
                      getBirthDateStudents(false, true)
                    }
                  "
                >
                  <v-list-tile-action>
                    <v-icon
                      :color="
                        birthDate.selectedMonths.length > 0 ? 'primary' : ''
                      "
                    >
                      {{ iconBirthdate }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <template v-slot:selection="{ item, index }">
                <div v-if="index === 0">
                  <span
                    v-if="
                      birthDate.selectedMonths.length > 1 &&
                      birthDate.selectedMonths.length <
                        birthDate.allMonths.length
                    "
                  >
                    Filtrado
                  </span>
                  <span
                    v-else-if="
                      birthDate.selectedMonths.length ===
                      birthDate.allMonths.length
                    "
                  >
                    Todos
                  </span>
                  <span v-else-if="index === 0">{{ item.name }}</span>
                </div>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </div>
      <div
        id="birthdateStudentsSidePanel"
        style="height: 80%; overflow: scroll; background-color: #fafafa"
      >
        <div v-show="birthDate.isLoading">
          <v-progress-circular :size="50" color="primary" indeterminate />
        </div>

        <div v-show="!birthDate.isLoading" class="scroller px-4">
          <div
            v-for="item in birthDate.students"
            class="card my-2"
            :key="item.id"
          >
            <v-list>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-avatar>
                    <img
                      v-if="getAvatar(item)"
                      :src="getAvatar(item)"
                      alt="avatar"
                    />
                    <v-icon size="40" color="grey" v-else>
                      account_circle
                    </v-icon>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.firstName }} {{ item.lastName }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ item.level.typeLevel }} {{ item.gradeGroup.gradeGroup }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <span>{{ parseBirhDate(item.birthDate) }}</span>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </div>
          <div v-show="birthDate.loadingMore">
            <v-progress-circular :size="50" color="primary" indeterminate />
          </div>
          <div v-show="birthDate.students.length === 0">
            <p>Sin alumnos</p>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <v-layout row wrap>
      <v-toolbar class="main-tool-bar" scroll-target="#scrolling-home">
        <v-layout
          :wrap="$vuetify.breakpoint.xsOnly"
          py-2
          row
          ma-0
          fill-height
          align-center
          justify-end
        >
          <v-flex shrink mr-auto mb-3>
            <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
              {{ $t('students.students') }}
            </v-toolbar-title>
          </v-flex>
          <v-flex xs12 sm6 lg6 grow class="titleSearch">
            <v-text-field
              v-if="
                userPermissions[possibleUserModulePermissions.WATCH_STUDENTS]
              "
              :disabled="loading"
              prepend-inner-icon="search"
              flat
              :label="$t('students.search')"
              @click:append-outer="filterSearch"
              @click:clear="clearSearch"
              @keyup.enter="filterSearch"
              v-model="filters.search"
              solo-inverted
              clearable
            />
          </v-flex>
          <v-flex xs12 sm4 lg3 shrink>
            <clear-filters @click="removeFilters" v-if="filtersRemove" />
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!selected.length > 0"
                  @click="deleteConfirm"
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.DELETE_STUDENTS
                    ]
                  "
                  icon
                >
                  <v-icon color="primary"> delete </v-icon>
                </v-btn>
              </template>
              <span v-show="selected.length == 1">
                {{ $t('students.delete_student') }}
              </span>
              <span v-show="selected.length > 1">
                {{ $t('students.delete_students') }}
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="
                userPermissions[possibleUserModulePermissions.BLOCK_STUDENTS_QR]
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="massiveQrHandler"
                  :disabled="massiveQrBtn.isDisabled"
                  icon
                >
                  <v-icon color="primary">{{ massiveQrBtn.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ massiveQrBtn.tooltipText }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="drawer = !drawer">
                  <v-icon color="primary">cake</v-icon>
                </v-btn>
              </template>
              <span>Cumpleaños</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-speed-dial
          v-if="
            userPermissions[possibleUserModulePermissions.WATCH_STUDENTS] &&
            (userPermissions[possibleUserModulePermissions.ADD_STUDENTS] ||
              userPermissions[
                possibleUserModulePermissions.DOWNLOAD_STUDENTS
              ] ||
              userPermissions[
                possibleUserModulePermissions.DOWNLOAD_STUDENTS_PARENTS
              ])
          "
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('students.options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip
            right
            v-if="userPermissions[possibleUserModulePermissions.ADD_STUDENTS]"
          >
            <v-btn
              color="gradiente"
              slot="activator"
              dark
              fab
              small
              @click="addStudent"
            >
              <v-icon>person_add</v-icon>
            </v-btn>
            <span>{{ $t('students.create_student') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              v-if="
                userPermissions[possibleUserModulePermissions.DOWNLOAD_STUDENTS]
              "
              @click="downloadStudents"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>{{ $t('students.download_students') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              v-if="
                userPermissions[
                  possibleUserModulePermissions.DOWNLOAD_STUDENTS_PARENTS
                ]
              "
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadStudentsParents"
            >
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <span>{{ $t('students.download_tutors_and_students') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              v-show="
                userPermissions[
                  possibleUserModulePermissions.DOWNLOAD_STUDENTS
                ] &&
                (totalItemsFromBackend > 0 || selected.length > 0)
              "
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="showQrSizeModalAll"
            >
              <v-icon>qr_code</v-icon>
            </v-btn>
            <span>{{ $t('students.download_qr_s') }}</span>
          </v-tooltip>
          <!-- <v-tooltip right>
            <v-btn
              v-if="permits['IMPORT_STUDENTS']"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="importStudents"
            >
              <v-icon>upload_file</v-icon>
            </v-btn>
            <span>Importar alumnos</span>
          </v-tooltip> -->
          <v-tooltip right>
            <v-btn
              v-if="
                userPermissions[
                  possibleUserModulePermissions.IMPORT_STUDENTS_PARENTS
                ]
              "
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="importStudentsAndParents"
            >
              <v-icon>upload_file</v-icon>
            </v-btn>
            <span>{{ $t('students.import_students_and_tutors') }}</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>

      <v-container
        fluid
        elevation-2
        class="scrollDesign table-full"
        style="height: 130%"
      >
        <v-layout row wrap style="height: 130%">
          <v-flex xs12 style="height: 130%" class="ma-12">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              :rows-per-page-text="$t('students.records_per_page')"
              :total-items="totalItemsFromBackend"
              :items="students"
              :loading="loading"
              :expand="expand"
              :pagination.sync="pagination"
              ref="table"
              item-key="id"
              select-all
              no-results-text="No se encontraron coincidencias"
              :no-data-text="
                userPermissions[possibleUserModulePermissions.WATCH_STUDENTS]
                  ? loading
                    ? 'Cargando'
                    : students.length > 0
                    ? ''
                    : 'No hay alumnos'
                  : 'No tienes permiso de ver alumnos'
              "
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    />
                  </th>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    {{ props.headers[0].text }}
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 180px; max-width: 180px; min-width: 180px"
                    @click="changeSort(props.headers[1].value)"
                  >
                    {{ props.headers[1].text }}
                    <SortTableArrow
                      :is-active="props.headers[1].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 180px; max-width: 180px; min-width: 180px"
                    @click="changeSort(props.headers[2].value)"
                  >
                    {{ props.headers[2].text }}
                    <SortTableArrow
                      :is-active="props.headers[2].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 180px; max-width: 180px; min-width: 180px"
                  >
                    Apellido materno
                  </th>
                  <!-- TODO: Taller descomentar o ver el setting -->
                  <th
                    v-if="isNormalSchool()"
                    class="text-xs-left"
                    style="
                      width: 180px;
                      max-width: 180px;
                      min-width: 180px;
                      position: relative;
                    "
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ]
                          ? props.headers[3].filterItems
                          : []
                      "
                      item-value="levelId"
                      item-text="levelName"
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterLevel(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="filters.levelIds"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">{{
                          props.headers[3].text
                        }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.levelIds.length +
                            ' filtro' +
                            (filters.levelIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                    <SortTableArrow
                      class="sort_arrow"
                      @click="changeSort(props.headers[3].value)"
                      :is-active="props.headers[3].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    v-if="isNormalSchool()"
                    class="text-xs-left"
                    style="
                      width: 140px;
                      max-width: 140px;
                      min-width: 140px;
                      position: relative;
                    "
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ]
                          ? props.headers[4].filterItems
                          : []
                      "
                      item-value="groupId"
                      item-text="groupName"
                      :disabled="loading"
                      outline
                      v-model="filters.gradeGroupIds"
                      height="50"
                      @change="filterGgs(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">
                          {{ $t('students.group') }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.gradeGroupIds.length +
                            ' filtro' +
                            (filters.gradeGroupIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                    <SortTableArrow
                      class="sort_arrow"
                      @click="changeSort(props.headers[4].value)"
                      :is-active="props.headers[4].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    v-if="isNormalSchool()"
                    class="text-xs-left"
                    style="width: 150px; max-width: 150px; min-width: 150px"
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ] &&
                        userPermissions[
                          possibleUserModulePermissions.WATCH_PARENTS
                        ]
                          ? props.headers[5].filterItems
                          : []
                      "
                      item-text="name"
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterParent"
                      v-model="filters.parents"
                      :dense="$vuetify.breakpoint.xsOnly"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">
                          {{ props.headers[5].text }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                          v-if="index === filters.parents.length - 1"
                          class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.parents.length +
                            ' filtro' +
                            (filters.parents.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 150px; max-width: 150px; min-width: 150px"
                  >
                    <v-select
                      v-model="filters.gender"
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ]
                          ? props.headers[6].filterItems
                          : []
                      "
                      item-text="text"
                      item-value="value"
                      multiple
                      outline
                      :disabled="loading"
                      height="50"
                      @change="filterGenders"
                      :dense="$vuetify.breakpoint.xsOnly"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">
                          {{ props.headers[6].text }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                          v-if="index === filters.gender.length - 1"
                          class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.gender.length +
                            ' filtro' +
                            (filters.gender.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.DOWNLOAD_STUDENTS
                      ]
                    "
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ $t('students.qr_code') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 185px; max-width: 185px; min-width: 185px"
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.BLOCK_STUDENTS_QR
                      ]
                    "
                  >
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          outline
                          v-on="on"
                          style="
                            border: 2px solid gray;
                            border-radius: 4px;
                            color: gray;
                          "
                        >
                          Estatus QR
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in props.headers[7].filterItems"
                          ripple
                          :key="index"
                          @click=""
                        >
                          <v-checkbox
                            v-if="item.text === 'Suspendido'"
                            color="primary"
                            v-model="qrArray"
                            :label="item.text"
                            :value="item.value"
                            @change="onChange"
                          />
                          <v-checkbox
                            v-else
                            color="primary"
                            v-model="qrArray"
                            :label="item.text"
                            :value="item.value"
                            @change="onChange"
                          />
                        </v-list-tile>
                      </v-list>
                      <v-list class="pt-0">
                        <v-list-tile
                          v-for="(item, index) in props.headers[7]
                            .filterItems[1].nested"
                          ripple
                          :key="index"
                          @click=""
                        >
                          <v-checkbox
                            class="pl-4"
                            color="primary"
                            v-model="qrArray"
                            :label="item.text"
                            :value="item.value"
                            @change="onChange2"
                          >
                          </v-checkbox>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 168px; max-width: 168px; min-width: 168px"
                    @click="changeSort(props.headers[8].value)"
                  >
                    {{ isNormalSchool() ? $t('students.student_id') : 'CURP' }}
                    <SortTableArrow
                      :is-active="props.headers[8].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.WATCH_PARENTS
                      ] && isNormalSchool()
                    "
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Extracurricular
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                    v-if="!isNormalSchool()"
                  >
                    Código postal
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 210px; max-width: 210px; min-width: 210px"
                  >
                    Correo electrónico
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Teléfono
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Ciudad
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Tenencia
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Colonia
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Estado
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Calle
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Referencias
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Incapacidades físicas
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Número
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Red social
                  </th>
                  <th
                    v-if="!isNormalSchool()"
                    class="text-xs-left"
                    style="width: 143px; max-width: 143px; min-width: 143px"
                  >
                    Talleres
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 78px; max-width: 78px; min-width: 78px"
                  />
                </tr>
              </template>
              <template
                v-slot:items="props"
                style="max-height: calc(100vh - 426px); min-height: 40vh"
              >
                <td
                  class="text-xs-left"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                >
                  <v-checkbox
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td
                  class="text-xs-left"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                >
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    color="grey lighten-4"
                    v-if="
                      props.item.imageStorage &&
                      props.item.imageStorage.miniObjUrl
                    "
                  >
                    <img
                      :src="props.item.imageStorage.miniObjUrl"
                      alt="avatar"
                    />
                  </v-avatar>
                  <v-icon v-else> account_circle </v-icon>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 180px; max-width: 180px; min-width: 180px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthFirstName'
                  "
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.firstName }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 180px; max-width: 180px; min-width: 180px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthLastName'
                  "
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.lastName }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 180px; max-width: 180px; min-width: 180px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthLastName'
                  "
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.maternalSurname }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  v-if="isNormalSchool()"
                  class="text-xs-left"
                  style="width: 180px; max-width: 180px; min-width: 180px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthNivel'
                  "
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.level.typeLevel }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  v-if="isNormalSchool()"
                  class="text-xs-left"
                  style="width: 140px; max-width: 140px; min-width: 140px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.gg.grade + ' ' + props.item.gg.group }}
                  </CustomTooltipOverflowText>
                </td>
                <div v-if="isNormalSchool()">
                  <td
                    style="width: 150px; max-width: 150px; min-width: 150px"
                    :class="props.item.id == colapSel ? 'little-green' : ''"
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.WATCH_PARENTS
                      ]
                    "
                    @click="expandParents(props)"
                  >
                    <v-btn icon>
                      <v-badge
                        :color="props.item.parents.length ? 'green' : 'red'"
                      >
                        <template v-slot:badge>
                          <span>{{ props.item.parents.length }}</span>
                        </template>
                        <v-icon class="no-border">
                          {{
                            !props.item.parents.length
                              ? 'person_outline'
                              : props.item.parents.length == 1
                              ? 'person'
                              : 'group'
                          }}
                        </v-icon>
                      </v-badge>
                    </v-btn>
                  </td>
                  <td
                    v-else-if="
                      userPermissions[
                        possibleUserModulePermissions.WATCH_PARENTS
                      ]
                    "
                  ></td>
                  <td
                    v-else
                    class="text-xs-left"
                    style="width: 150px; max-width: 150px; min-width: 150px"
                    :class="props.item.id == colapSel ? 'little-green' : ''"
                  >
                    No autorizado
                  </td>
                </div>
                <td
                  style="width: 150px; max-width: 150px; min-width: 150px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-avatar>
                    <v-icon
                      :color="props.item.gender == 'MALE' ? 'blue' : 'pink'"
                    >
                      account_circle
                    </v-icon>
                  </v-avatar>
                </td>
                <td
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.DOWNLOAD_STUDENTS
                    ]
                  "
                  style="width: 100px; max-width: 100px; min-width: 100px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-btn
                    icon
                    v-if="
                      props.item.qrImageStorage &&
                      props.item.qrImageStorage.miniObjUrl
                    "
                    @click="showQrSizeModal(props.item)"
                    :class="props.item.id == colapSel ? 'little-green' : ''"
                  >
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                    >
                      <img
                        :key="ck"
                        :src="props.item.qrImageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                  </v-btn>
                  <v-icon v-else> no_sim </v-icon>
                </td>

                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: green;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    props.item.qrEnabled == true &&
                    userPermissions[
                      possibleUserModulePermissions.BLOCK_STUDENTS_QR
                    ]
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          userPermissions[
                            possibleUserModulePermissions.BLOCK_STUDENTS_QR
                          ]
                        "
                        @click="bloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock_open</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('students.suspend_qr') }}</span>
                  </v-tooltip>
                  Activo
                </td>

                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: red;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    props.item.qrEnabled == false &&
                    userPermissions[
                      possibleUserModulePermissions.BLOCK_STUDENTS_QR
                    ]
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          userPermissions[
                            possibleUserModulePermissions.BLOCK_STUDENTS_QR
                          ]
                        "
                        @click="desbloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock</v-icon>
                      </v-btn>
                    </template>
                    <span>Activar QR</span>
                  </v-tooltip>

                  <v-tooltip right max-width="250px">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">Suspendido</span>
                    </template>
                    <span>{{ props.item.qrDisabledReason }}</span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-left"
                  style="width: 168px; max-width: 168px; min-width: 168px"
                  :class="props.item.id == colapSel ? 'little-green' : '' + ''"
                >
                  {{ props.item.personId }}
                </td>

                <td
                  style="width: 143px; max-width: 143px; min-width: 143px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.WATCH_PARENTS
                    ] && isNormalSchool()
                  "
                  @click="expandExtras(props)"
                >
                  <v-btn icon>
                    <v-badge :color="props.item.extras ? 'green' : 'red'">
                      <template v-slot:badge>
                        <span>{{
                          props.item.extras ? props.item.extras.length : 0
                        }}</span>
                      </template>
                      <v-icon class="no-border">
                        {{ 'sports_soccer' }}
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  {{ props.item.zipCode }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 210px; max-width: 210px; min-width: 210px"
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.email }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.phone }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.city }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.tenantry }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.suburb }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.state }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.street }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.reference }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.impairment }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.extNumber }}
                </td>
                <td
                  v-if="!isNormalSchool()"
                  class="text-xs-left"
                  style="width: 143px; max-width: 143px; min-width: 143px"
                >
                  {{ props.item.socialContacts }}
                </td>

                <td
                  style="width: 143px; max-width: 143px; min-width: 143px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                  v-if="!isNormalSchool()"
                  @click="expandWorshop(props)"
                >
                  <v-btn icon>
                    <v-badge
                      :color="props.item.historyCourses ? 'green' : 'red'"
                    >
                      <template v-slot:badge>
                        <span>{{
                          props.item.historyCourses
                            ? props.item.historyCourses.length
                            : 0
                        }}</span>
                      </template>
                      <v-icon class="no-border">
                        {{ 'sports_soccer' }}
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </td>
                <td style="width: 78px; max-width: 78px; min-width: 78px">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          userPermissions[
                            possibleUserModulePermissions.UPDATE_STUDENTS
                          ]
                        "
                        @click="editStudent(props.item)"
                        icon
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('students.edit_student') }}</span>
                  </v-tooltip>
                </td>
              </template>
              <template v-slot:expand="props">
                <student-workshops
                  v-if="expandables.workshop"
                  :extras="props.item.historyCourses"
                  :student-name="props.item.firstName"
                  :student-id="props.item.id"
                />
                <StudentExtras
                  v-if="expandables.extras"
                  :extras="props.item.extras"
                  :student-name="props.item.firstName"
                  :student-id="props.item.id"
                  :permits="userPermissions"
                />
                <StudentTutors
                  v-if="expandables.parents"
                  :parents="props.item.parents"
                  :student-name="props.item.firstName"
                  :student-id="props.item.id"
                  :permits="userPermissions"
                />
                <v-divider />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <StudentModal
        @onClosed="onCancel"
        @deletePhoto="deletePhoto"
        :class="!modals.student ? 'position-no' : ''"
        :title="modals.title"
        :parent="null"
        :value="modals.value"
        :student="select.student"
        @created="createStudent"
        @updated="updateStudent"
        v-model="modals.student"
        :permits="userPermissions"
      />
      <add-student-v-2
        @onClosed="onCancel"
        :class="!modals.student_v2 ? 'position-no' : ''"
        :title="modals.title"
        :parent="null"
        :value="modals.value"
        :student="select.student"
        :branch="getBranch"
        @created="createStudent"
        @updated="updateStudent"
        v-model="modals.student_v2"
      />
      <confirm
        :class="!confirm.value ? 'position-no' : ''"
        :value="confirm.value"
        :title="confirm.title"
        :description="confirm.description"
        @desition="desitionDelete"
      />
      <QRSizeModal
        @onClosed="onCancel"
        :class="!QRSizeModal.value ? 'position-no' : ''"
        v-model="QRSizeModal.value"
        :value="QRSizeModal.value"
        :title="QRSizeModal.title"
        :std="true"
        @desition="desitionSize"
        @archivoName="archivoName"
      />
      <!-- <ImportStudent
        @correct="imported"
        v-model="modals.import"
        :mats="matriculas"
      /> -->
      <ImportStudentsParents
        @onClosed="onCancel"
        @getStudents="getStudentsOfBranch"
        v-model="modals.importParents"
        :mats="matriculas"
        @imported="importedStdsParents"
        @progress="stepProgress"
      />
      <loading v-model="working.wLoading" text="Trabajando" />
      <success v-model="toast.success" text="Operación Exitosa" />
      <error v-model="toast.failed" text="Ups ocurrió un error" />
      <SuperLoading
        :show="superLoading.show"
        :value="superLoading.value"
        :total="superLoading.total"
      />
      <QRBlock
        v-model="blockQR"
        :student="select.student"
        @updated="updateStudent"
        :std="true"
      />
      <QRDesblock
        v-model="desblockQR"
        :student="select.student"
        @updated="updateStudent"
        :std="true"
      />
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import confirm from '../../../Dialogs/Confirm'
import error from '../../../Dialogs/Error'
import loading from '../../../Dialogs/Loading'
import success from '../../../Dialogs/Success'
import QRSizeModal from '../../../Modals/QRModalStd'
import StudentModal from '../../../Modals/StudentModal.vue'
import StudentExtras from '../../../Sections/Students/Student-extras.vue'
import StudentTutors from '../../../Sections/Students/Student-tutors.vue'
import ClearFilters from '../../../Tools/ClearFilters.vue'
import SuperLoading from '../../../Tools/SuperLoading'
// import ImportStudent from "../../Modals/ImportStudent";
import { funciones } from '../../../../Mixins/Funciones'
import { pdfMixin } from '../../../../Mixins/PdfMixin'
import { isNormalSchool } from '../../../../plugins/GeneralMethods'
import QRBlock from '../../../Modals/BloqQR.vue'
import QRDesblock from '../../../Modals/DesbloqQR.vue'
import ImportStudentsParents from '../../../Modals/ImportStudentsParents.vue'
import AddStudentV2 from '../../../Modals/students/AddStudentV2.vue'
import StudentWorkshops from '../../../Sections/Students/Student-workshops.vue'
import SortTableArrow from '../../../Tools/SortTableArrow.vue'
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'

import { _getUserPermissions } from '../../../../utils/genericUtils'
import {
  filterByGroup,
  filterByLevel,
  isEmpty,
  isNotEmpty,
  parseGroups,
  parseLevels,
} from './utils'

import { _downloadFileFromContentDisposition } from '../../../../utils/genericUtils.js'

export default {
  components: {
    StudentModal,
    confirm,
    StudentTutors,
    SuperLoading,
    loading,
    success,
    error,
    QRSizeModal,
    // ImportStudent,
    ImportStudentsParents,
    StudentExtras,
    ClearFilters,
    QRBlock,
    QRDesblock,
    AddStudentV2,
    StudentWorkshops,
    SortTableArrow,
    CustomTooltipOverflowText,
  },
  mixins: [funciones, pdfMixin],
  props: {},
  data: () => {
    return {
      drawer: false,
      /**
       * @typedef {Object} masiveQrBtn
       * @property {boolean} isDisabled
       * @property {'lock'|'lock_open'} icon
       * @property {boolean} isSuspensionQrEvent
       * @property {'Suspensión masiva de QR' | 'Activación masiva de QR'} tooltipText
       */
      /**
       * @type {masiveQrBtn}
       */
      massiveQrBtn: {
        isDisabled: true,
        icon: 'lock',
        isSuspensionQrEvent: true,
        tooltipText: 'Suspensión masiva de QR',
      },
      isNormalSchoolValue: true,
      posibleFilters: {
        levels: [],
        gradeGroups: [],
      },
      expandables: {
        parents: false,
        extras: false,
        workshop: false,
      },
      blockQR: false,
      desblockQR: false,
      colapSel: 0,
      studentsSingle: [],
      students: [],
      avatarSize: '30px',
      gotImages: 0,
      gotQrs: 0,
      ck: 0,
      superLoading: {
        show: false,
        value: 0,
        total: 0,
      },
      loading: true,
      expand: false,
      working: {
        wStudent: false,
        wLoading: false,
      },
      tile: false,
      totalItemsFromBackend: 0,
      headers: [
        {
          text: 'Foto',
          align: 'center',
          sortable: false,
          value: 'photo',
          langKey: 'students.photo',
        },
        {
          text: 'Nombre',
          value: 'NAME',
          align: 'center',
          sortable: true,
          langKey: 'students.first_name',
        },
        {
          text: 'Apellidos',
          value: 'LAST_NAME',
          sortable: true,
          align: 'center',
          langKey: 'students.last_name',
        },
        {
          text: 'Nivel',
          value: 'LEVEL',
          sortable: true,
          filterItems: [],
          align: 'center',
          langKey: 'students.level',
        },
        {
          text: 'Grado y Grupo',
          value: 'GROUP',
          sortable: true,
          filterItems: [],
          align: 'center',
          langKey: 'students.group',
        },
        {
          text: 'Tutores',
          value: 'parents',
          filterItems: [],
          sortable: false,
          align: 'center',
          langKey: 'students.tutors',
        },
        {
          text: 'Sexo',
          value: 'gender',
          filterItems: [
            {
              text: 'Masculino',
              value: 'MALE',
              langKey: 'students.male',
            },
            {
              text: 'Femenino',
              value: 'FEMALE',
              langKey: 'students.female',
            },
          ],
          align: 'center',
          sortable: false,
          langKey: 'students.gender',
        },
        {
          text: 'Estatus QR',
          value: 'qrEnabled',
          filterItems: [
            {
              text: 'Activos',
              value: 'active',
            },
            {
              text: 'Suspendido',
              value: 'suspend',
              nested: [
                { text: 'Indisciplina', value: 'INDISCIPLINE' },
                { text: 'Falta de Pago', value: 'FAILED_PAYMENT' },
                { text: 'Retardos', value: 'DELAYS' },
                { text: 'Otros motivos', value: 'OTHER' },
              ],
            },
          ],
          align: 'center',
          sortable: false,
          langKey: 'students.qr_status',
        },
        {
          text: 'Matrícula',
          value: 'PERSON_ID',
          sortable: true,
          align: 'center',
          langKey: 'students.student_id',
        },
        {
          text: 'Extracurricular',
          value: 'extra',
          sortable: false,
          align: 'center',
        },
      ],
      pagination: {
        sortBy: 'NAME',
        descending: false,
        total: 0,
        page: 1,
        rowsPerPage: 25,
      },
      buttonFab: {
        fab: false,
        hidden: false,
      },
      filters: {
        size: 0,
        space: false,
        offset: 0,
        orderBy: 'NAME',
        orderType: 'asc',
        search: '',
        levelIds: [],
        gradeGroupIds: [],
        gender: [],
        parents: [],
        qrEnabled: null,
      },
      firstCharge: false,
      selected: [],

      modals: {
        title: '',
        student: false,
        student_v2: false,
        import: false,
        importParents: false,
      },
      select: {
        student: null,
      },
      toast: {
        success: false,
        failed: false,
      },
      confirm: {
        value: false,
        title: '',
        description: '',
        show: false,
      },
      parentSendEmail: {},
      QRSizeModal: {
        title: '',
        value: '',
        student: [],
      },
      listChildsGGs: [],
      allQrs: false,
      // permits: [],
      userPermissions: {},
      possibleUserModulePermissions: {
        // STUDENTS/PARENTS
        IMPORT_STUDENTS_PARENTS: 'IMPORT_STUDENTS_PARENTS',
        LINK_STUDENTS_PARENTS: 'LINK_STUDENTS_PARENTS',
        DOWNLOAD_STUDENTS_PARENTS: 'DOWNLOAD_STUDENTS_PARENTS',
        // STUDENTS
        WATCH_STUDENTS: 'WATCH_STUDENTS',
        ADD_STUDENTS: 'ADD_STUDENTS',
        DELETE_STUDENTS: 'DELETE_STUDENTS',
        UPDATE_STUDENTS: 'UPDATE_STUDENTS',
        DOWNLOAD_STUDENTS: 'DOWNLOAD_STUDENTS',
        IMPORT_STUDENTS: 'IMPORT_STUDENTS',
        BLOCK_STUDENTS_QR: 'BLOCK_STUDENTS_QR',
        // PARENTS
        WATCH_PARENTS: 'WATCH_PARENTS',
        ADD_PARENTS: 'ADD_PARENTS',
        UPDATE_PARENTS: 'UPDATE_PARENTS',
        DELETE_PARENTS: 'DELETE_PARENTS',
        SEND_PARENTS: 'SEND_PARENTS',
        DOWNLOAD_PARENTS: 'DOWNLOAD_PARENTS',
        WATCH_PARENTS_CODE: 'WATCH_PARENTS_CODE',
        BLOCK_PARENTS_QR: 'BLOCK_PARENTS_QR',
      },
      colapSel: null,
      matriculas: {},
      masiveQR: {
        isSmall: false,
        pageBreak: false,
      },
      gradegroups: {},
      documentName: '',
      qrArray: [],
      birthDate: {
        allMonths: [],
        selectedMonths: [],
        students: [],
        totalStudents: 0,
        isLoading: false,
        search: '',
        loadingMore: false,
        offset: 0,
      },
    }
  },
  watch: {
    drawer: async function () {
      if (this.drawer) {
        this.birthDate = {
          ...this.birthDate,
          selectedMonths: (this.birthDate.selectedMonths = [
            this.birthDate.allMonths[this.getCurrentMonth()].value,
          ]),
          students: [],
          totalStudents: 0,
          isLoading: false,
          search: '',
          loadingMore: false,
          offset: 0,
        }
        await this.getBirthDateStudents()

        if (this.drawer) {
          document
            .getElementById('birthdateStudentsSidePanel')
            .addEventListener('scroll', this.handleScroll)
        }
      }
    },
    selected() {
      this._massiveQrBtn()
    },
    getBranch() {
      if (
        this.userPermissions[
          this.possibleUserModulePermissions.WATCH_STUDENTS
        ] &&
        this.students.length === 0
      ) {
        this.filters.size = this.pagination.rowsPerPage
        this.filters.offset = 0
        this.filters.orderBy = 'NAME'
        this.filters.orderType = 'ASC'
        this.getStudentsOfBranch()
      }
    },
    getUser() {
      this.mapPermits()
      if (
        this.userPermissions[
          this.possibleUserModulePermissions.WATCH_STUDENTS
        ] &&
        !this.students.length > 0 &&
        this.getBranch.id
      ) {
        this.filters.size = this.pagination.rowsPerPage
        this.filters.offset = 0
        this.filters.orderBy = 'NAME'
        this.filters.orderType = 'ASC'
        this.getStudentsOfBranch()
      }
    },
    loading() {
      if (!this.loading) {
      }
    },
    pagination: {
      handler() {
        if (
          this.userPermissions[
            this.possibleUserModulePermissions.WATCH_STUDENTS
          ] &&
          this.students &&
          this.getBranch.id &&
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          this.getStudentsOfBranch()
        }
      },
      deep: true,
    },
    getLang() {
      this.setLang()
    },
  },
  created() {
    this.isNormalSchoolValue = this.isNormalSchool()
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }
    this.birthDate.allMonths = this.createMonths()
    this.birthDate.selectedMonths = [
      this.birthDate.allMonths[this.getCurrentMonth()].value,
    ]
    this.getBirthDateStudents()
    this.getGGS()
    this._setupLevels()
    this.setLang()
  },
  beforeMount() {},
  methods: {
    onChange() {
      if (this.qrArray.includes('suspend')) {
        const temp = new Set(this.qrArray)
        this.headers[7].filterItems[1].nested.forEach((e) => {
          temp.add(e.value)
        })
        this.qrArray = Array.from(temp)
        this.getStudentsOfBranch()
        return
      }

      if (!this.qrArray.includes('suspend')) {
        this.headers[7].filterItems[1].nested.forEach((el) => {
          this.qrArray = this.qrArray.filter((e) => e !== el.value)
        })
      }
      this.getStudentsOfBranch()
    },
    onChange2() {
      const types = ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER']
      if (this.qrArray.map((e) => types.some((x) => x === e))) {
        const temp = new Set(this.qrArray)
        temp.add('suspend')
        this.qrArray = Array.from(temp)
      }
      this.getStudentsOfBranch()
    },
    setLang() {
      for (let i = 0; i < this.headers.length; i++) {
        const el = this.headers[i]
        el.text = this.$t(el.langKey)

        if (el.value === 'gender') {
          el.filterItems = el.filterItems.map((e) => {
            return {
              ...e,
              text: this.$t(e.langKey),
            }
          })
        }
      }
    },
    _massiveQrBtn() {
      if (this.selected.length === 0) {
        this.massiveQrBtn.isDisabled = true
        this.massiveQrBtn.icon = 'lock'
        this.massiveQrBtn.isSuspensionQrEvent = true
        this.massiveQrBtn.tooltipText = 'Suspensión masiva de QR'
        return
      }

      const isSomeEnabled = this.selected.some((e) => e.qrEnabled === true)
      const isSomeDisabled = this.selected.some((e) => e.qrEnabled === false)

      if (isSomeEnabled === true && isSomeDisabled === true) {
        this.massiveQrBtn.isDisabled = true
        this.massiveQrBtn.icon = 'lock'
        this.massiveQrBtn.isSuspensionQrEvent = true
        this.massiveQrBtn.tooltipText = 'Suspensión masiva de QR'
        return
      }

      if (isSomeEnabled === true) {
        this.massiveQrBtn.isDisabled = false
        this.massiveQrBtn.icon = 'lock'
        this.massiveQrBtn.isSuspensionQrEvent = true
        this.massiveQrBtn.tooltipText = 'Suspensión masiva de QR'
        return
      }

      this.massiveQrBtn.isDisabled = false
      this.massiveQrBtn.icon = 'lock_open'
      this.massiveQrBtn.isSuspensionQrEvent = false
      this.massiveQrBtn.tooltipText = 'Activación masiva de QR'
    },
    massiveQrHandler() {
      if (this.massiveQrBtn.isSuspensionQrEvent === true) {
        this.select.student = this.selected
        this.blockQR = true
        return
      }

      this.select.student = this.selected
      this.desblockQR = true
    },
    desbloqQR(student) {
      this.select.student = student
      this.desblockQR = true
    },
    async _setupLevels() {
      const { data } = await this.$store.dispatch('student/getStudentsFilters')

      const levels = parseLevels({ levels: data })
      const groups = parseGroups({ gradeGroups: data })
      this.headers[3].filterItems = levels
      this.headers[4].filterItems = groups
      this.posibleFilters = { ...this.posibleFilters, levels: levels }
      this.posibleFilters = { ...this.posibleFilters, gradeGroups: groups }
    },
    isNormalSchool() {
      return isNormalSchool(this.getBranch)
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    // mapPermits() {
    //   var usr = this.getUser
    //   var wbRol = usr.webRole
    //   var catalogs = wbRol.catalogs
    //   for (var c in catalogs) {
    //     if (
    //       catalogs[c].name.includes('STUDENTS') ||
    //       catalogs[c].name.includes('PARENTS') ||
    //       catalogs[c].name.includes('PAYMENTS')
    //     ) {
    //       this.permits[catalogs[c].name] = 1
    //     }
    //   }

    //   this.loading = this.permits['WATCH_STUDENTS'] ? true : false
    // },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async getStudentsOfBranch() {
      this.filters.includeQr = true
      this.loading = true

      const temp = {
        ...structuredClone(this.filters),
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
        search: this.filters.search === '' ? undefined : this.filters.search,
      }
      if (temp.qrEnabled === null) {
        delete temp.qrEnabled
      }

      this.$store
        .dispatch('student/getStudentsByBranch', temp)
        .then((response) => {
          this.students = response.data.entity
          this.totalItemsFromBackend = response.data.filters.total
          this.firstCharge = true
          this.getQrPerUser()
          this.applyFilters(response.data.filters)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    applyFilters(newFilters) {
      // if (this.filters.levelIds.length == 0) {
      // 	this.headers[3].filterItems = [];
      // 	for (const [index, item] of newFilters.levels.entries()) {
      // 		this.headers[3].filterItems.push(item);
      // 	}
      // 	this.$forceUpdate();
      // }
      // if (this.filters.gradeGroupIds.length == 0) {
      // 	this.headers[4].filterItems = [];
      // 	for (const [index, item] of newFilters.ggs.entries()) {
      //     if(!item.includes('null'))
      // 		  this.headers[4].filterItems.push(item);
      // 	}
      // 	this.$forceUpdate();
      // }
      if (this.filters.parents.length == 0) {
        this.headers[5].filterItems = []
        for (const [index, item] of newFilters.parents.entries()) {
          this.headers[5].filterItems.push(item)
        }
        this.$forceUpdate()
      }
      // if (this.filters.gender.length == 0) {
      //   this.headers[6].filterItems = []
      //   for (const [index, item] of newFilters.gender.entries()) {
      //     this.headers[6].filterItems.push({
      //       value: item,
      //       text: item === 'MALE' ? 'Masculino' : 'Femenino',
      //     })
      //   }
      //   this.$forceUpdate()
      // }
    },
    // filterLevels() {
    // 	var listChildsLvls = [];
    // 	var count = 0;
    // 	for (var student in this.students) {
    // 		listChildsLvls[this.students[student].level.typeLevel] = 1;
    // 		if (!this.listChildsGGs[this.students[student].level.typeLevel]) {
    // 			this.listChildsGGs[this.students[student].level.typeLevel] = [];
    // 		}
    // 		if (
    // 			this.listChildsGGs[this.students[student].level.typeLevel].indexOf(
    // 				"" +
    // 					this.students[student].gg.grade +
    // 					this.students[student].gg.group
    // 			) == -1
    // 		) {
    // 			this.listChildsGGs[this.students[student].level.typeLevel].push(
    // 				"" +
    // 					this.students[student].gg.grade +
    // 					this.students[student].gg.group
    // 			);
    // 		}
    // 	}

    // 	for (var num in listChildsLvls) {
    // 		if (listChildsLvls[num]) {
    // 			this.headers[3].filterItems.push(num);
    // 		}
    // 	}
    // },
    filterParents() {
      var listParents = []
      for (var student in this.students) {
        listParents[this.students[student].parents.length] = 1
      }
      for (var num in listParents) {
        if (listParents[num]) {
          this.headers[5].filterItems.push(num)
        }
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.table.filteredItems.slice()
    },

    filterStudents(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters.numStd, {
        numStd: val,
      })
    },
    getQrPerUser() {
      this.loading = false
    },
    getSingleQr(id) {
      return this.$store.dispatch('student/getQrOfStudent', id)
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers)

      cf.registerFilter('search', function (searchWord, items) {
        if (searchWord == null || searchWord.trim() === '') return items
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = searchWord ? searchWord : ''
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return items.filter((item) => {
          return matcher.test(
            [
              item.firstName,
              item.lastName,
              item.firstName + ' ' + item.lastName,
              item.personId,
            ].join()
          )
        }, searchWord)
      })

      cf.registerFilter('level', function (level, items) {
        if (level.length == 0) return items

        return items.filter((item) => {
          for (var n in level) {
            if (item.level.typeLevel == level[n]) {
              return true
            }
          }
          return false
        }, level)
      })

      cf.registerFilter('ggs', function (ggs, items) {
        if (ggs.length == 0) return items

        return items.filter((item) => {
          for (var n in ggs) {
            if (item.gg.grade + item.gg.group == ggs[n]) {
              return true
            }
          }
          return false
        }, ggs)
      })

      // cf.registerFilter("genders", function(genders, items) {
      //   if (genders.length == 0) return items;

      //   return items.filter(item => {
      //     for (var n in genders) {
      //       var c = genders[n] == "Femenino" ? "FEMALE" : "MALE";
      //       if (item.gender == c) {
      //         return true;
      //       }
      //     }
      //     return false;
      //   }, genders);
      // });

      return cf.runFilters()
    },
    filterSearch(val) {
      if (!this.loading) {
        this.getStudentsOfBranch()
      }
    },
    _resetGgs() {
      this.headers[3].filterItems = this.posibleFilters.levels
    },
    async filterGgs(val) {
      if (!this.loading) {
        this.loading = true
        if (this.filters.gradeGroupIds.length === 0 && val === true) {
          // this.headers[3].filterItems = this.posibleFilters.levels
          this._resetGgs()
          await this.getStudentsOfBranch()
          return
        }

        const levels = filterByGroup({
          groupsIds: this.filters.gradeGroupIds,
          posibleGroups: this.posibleFilters.gradeGroups,
          posibleLevels: this.posibleFilters.levels,
        })

        this.headers[3].filterItems = levels
        await this.getStudentsOfBranch()

        if (
          isEmpty(this.students) &&
          isNotEmpty(this.filters.gradeGroupIds) &&
          isNotEmpty(this.filters.levelIds)
        ) {
          this.headers[3].filterItems = this.posibleFilters.levels
          this.headers[4].filterItems = this.posibleFilters.gradeGroups
          await this.getStudentsOfBranch()
        }
      }
      // if (!this.loading) {
      // 	this.getStudentsOfBranch();
      // }
    },
    filterGenders(val) {
      if (!this.loading) {
        this.getStudentsOfBranch()
      }
    },
    _resetLevels() {
      this.headers[4].filterItems = this.posibleFilters.gradeGroups
    },
    async filterLevel(val) {
      if (!this.loading) {
        this.loading = true
        if (this.filters.levelIds.length === 0 && val === true) {
          // this.headers[4].filterItems = this.posibleFilters.gradeGroups
          this._resetLevels()
          await this.getStudentsOfBranch()
          return
        }

        const groups = filterByLevel({
          levelIds: this.filters.levelIds,
          posibleGroups: this.posibleFilters.gradeGroups,
        })
        this.headers[4].filterItems = groups
        await this.getStudentsOfBranch()

        if (
          isEmpty(this.students) &&
          isNotEmpty(this.filters.gradeGroupIds) &&
          isNotEmpty(this.filters.levelIds)
        ) {
          this.headers[3].filterItems = this.posibleFilters.levels
          this.headers[4].filterItems = this.posibleFilters.gradeGroups
          await this.getStudentsOfBranch()
        }
      }
      // if (!this.loading) {
      // 	this.getStudentsOfBranch();
      // }
    },
    filterParent(val) {
      if (!this.loading) {
        this.getStudentsOfBranch()
      }
    },
    addStudent(event = null) {
      this.select.student = null
      this.modals.title = this.$t('students.create_student')
      if (this.isNormalSchool()) {
        this.modals.student = true
      } else {
        this.modals.student_v2 = true
      }
    },
    editStudent(student) {
      this.select.student = student
      if (this.isNormalSchool()) {
        this.modals.student = true
      } else {
        this.modals.student_v2 = true
      }
      this.modals.title = `${this.$t('students.edit_student')}`
    },
    bloqQR(student) {
      this.select.student = student
      this.blockQR = true
    },
    desbloqQR(student) {
      this.select.student = student
      this.desblockQR = true
    },
    updSTD() {
      this.$forceUpdate()
    },
    createStudent(event) {
      event.image = 'data:image/jpeg;base64,' + event.image
      event.parents = []
      this.students.unshift(event)
      this.getStudentsOfBranch()
      this.$forceUpdate()
    },
    updateStudent(event) {
      var i = this.students.findIndex((s) => s.id === this.select.student.id)
      if (i >= 0) {
        this.students[i].firstName = event.firstName
        this.students[i].lastName = event.lastName
        this.students[i].gender = event.gender
        this.students[i].gg = event.gg
        this.students[i].level = event.level
        this.students[i].personId = event.personId
        this.students[i].imageStorage = event.imageStorage
        this.students[i].qrEnabled = event.qrEnabled
        this.students[i].qrDisabledReason = event.qrDisabledReason
        this.students[i].email = event.email
        this.students[i].suburb = event.suburb
        this.students[i].city = event.city
        this.students[i].state = event.state
        this.students[i].street = event.street
        this.students[i].number = event.number
        this.students[i].extNumber = event.extNumber
        this.students[i].email = event.email
        this.students[i].socialContacts = event.socialContacts
        this.students[i].location = event.location
        this.students[i].phone = event.phone
        this.students[i].medicalNotes = event.medicalNotes
        this.students[i].familyResponsible = event.familyResponsible
      }
      this.select.student = null
      this.selected = []
      this.toast.success = true
      this.getStudentsOfBranch()
      this.$forceUpdate()
    },
    deleteConfirm() {
      this.confirm.description =
        'Esta a punto de eliminar ' +
        (this.selected.length == 1
          ? 'a ' + this.selected[0].firstName + ' ' + this.selected[0].lastName
          : this.selected.length + ' alumnos.\n') +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    desitionDelete(e) {
      if (e) {
        this.deleteStudents()
      } else {
        this.confirm.value = false
      }
    },
    deletePhoto(id) {
      this.working.wLoading = true
      this.$store
        .dispatch('student/deleteImage', id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.modals.student = false
          this.getStudentsOfBranch()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },
    deleteStudents() {
      this.working.wLoading = true
      this.$store
        .dispatch('student/deleteStudents', this.selected)
        .then((response) => {
          for (var e in this.selected) {
            this.students.splice(this.students.indexOf(this.selected[e]), 1)
          }
          this.selected = []
          this.working.wLoading = false
          this.toast.success = true
          this.confirm.value = false
          this.getStudentsOfBranch()
          this.$forceUpdate()
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          this.confirm.value = false
        })
    },
    downloadStudents() {
      const temp = {
        ...structuredClone(this.filters),
        size: this.selected.length === 0 ? 0 : undefined,
        studentIds:
          this.selected.length === 0
            ? undefined
            : this.selected.map((e) => e.id),
        // qrEnabled:
        //   this.filters.qrEnabled === null ? undefined : this.filters.qrEnabled,
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
      }

      this.working.wLoading = true
      this.$store
        .dispatch('student/getStudentsByBranchToCsv', temp)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'alumnos.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    downloadStudentsParents() {
      const temp = {
        ...structuredClone(this.filters),
        size: this.selected.length === 0 ? 0 : undefined,
        studentIds:
          this.selected.length === 0
            ? undefined
            : this.selected.map((e) => e.id),
        // qrEnabled:
        //   this.filters.qrEnabled === null ? undefined : this.filters.qrEnabled,
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
      }

      this.working.wLoading = true
      this.$store
        .dispatch('student/getStudentsParentsByBranchToCsv', temp)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'alumnos-papas.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    _downloadPdfQr(isSmall = true, pageBreak = true) {
      const params = {
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
        genders: isNotEmpty(this.filters.gender.length)
          ? this.filters.gender
          : undefined,
        search: isNotEmpty(this.selected)
          ? undefined
          : this.filters.search === ''
          ? undefined
          : this.filters.search,
        students: isNotEmpty(this.QRSizeModal.student)
          ? this.QRSizeModal.student.id
          : isEmpty(this.selected.length)
          ? undefined
          : this.selected.map((e) => e.id),
        parentCount: isNotEmpty(this.filters.parents.length)
          ? this.filters.parents
          : undefined,
        personId: undefined,
        firstName: undefined,
        lastName: undefined,
        isSmall: isSmall,
        pageBreak: pageBreak,
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
      }

      this.working.wLoading = true
      this.$store
        .dispatch('student/getStudentQRPdf', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          this.toast.text = 'Error al descargar pdf'
          this.QRSizeModal.student = []
          console.log(error)
        })
        .finally(() => {
          this.working.wLoading = false
          this.QRSizeModal.value = false
        })
    },
    _downloadQrImgs(fileNameInclude) {
      /**
       * Include values on file name
       */
      const fileName = Object.fromEntries(
        ['personId', 'firstName', 'lastName'].map((fileKey) => [
          fileKey,
          fileNameInclude.includes(fileKey),
        ])
      )

      const params = {
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
        genders: isNotEmpty(this.filters.gender.length)
          ? this.filters.gender
          : undefined,
        search: this.filters.search === '' ? undefined : this.filters.search,
        studentIds: isNotEmpty(this.QRSizeModal.student)
          ? this.QRSizeModal.student.id
          : isEmpty(this.selected.length)
          ? undefined
          : this.selected.map((e) => e.id),
        parentCount: isNotEmpty(this.filters.parents.length)
          ? this.filters.parents
          : undefined,
        personId: undefined,
        firstName: undefined,
        lastName: undefined,
        ...fileName,
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
      }

      this.working.wLoading = true
      this.$store
        .dispatch('student/getQrImgStudent', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
          this.QRSizeModal.value = false
        })
        .catch((error) => {
          this.toast.failed = true
          this.toast.text = 'Error al descargar archivo'
          console.log(error)
        })
        .finally(() => {
          this.working.wLoading = false
          this.QRSizeModal.value = false
        })
    },
    getGGS() {
      this.$store
        .dispatch('student/toolGetLevelsAndGGs')
        .then((response) => {
          this.gradegroups = response.data.entity
        })
        .catch((error) => {
          console.log(error)
        })
    },
    resendEmail(item) {
      this.working.wLoading = true
      this.$store
        .dispatch('tutor/resendEmail', { id: item.id })
        .then((response) => {
          this.working.wLoading = false
          this.toast.success = true
          this.parents[this.parents.indexOf(item)].code = response.data.entity
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.error = true
        })
    },
    downloadStudentAllQR(size, space) {
      this.working.wLoading = true
      this.allQrs = false

      const temp = {
        ...structuredClone(this.filters),
        qrEnabled:
          this.qrArray.includes('active') && this.qrArray.includes('suspend')
            ? null
            : this.qrArray.includes('active')
            ? true
            : this.qrArray.includes('suspend')
            ? false
            : null,
        disableType: this.qrArray.filter((e) =>
          ['INDISCIPLINE', 'FAILED_PAYMENT', 'DELAYS', 'OTHER'].includes(e)
        ),
      }
      fil.includeQr = true
      if (temp.qrEnabled === null) {
        delete temp.qrEnabled
      }
      delete fil.size
      delete fil.offset

      this.$store
        .dispatch('student/getStudentsByBranch', temp)
        .then((response) => {
          this.downloadStudentMasiveQR(
            response.data.entity,
            size,
            this.getBranch,
            space
          )
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    archivoName(e) {
      this._downloadQrImgs(e.std)
    },
    async desitionSize(e) {
      this.QRSizeModal.value = false
      const smallQr = 120
      const pageBreak = e.space === false
      this._downloadPdfQr(e.size === smallQr, pageBreak)
    },
    showQrSizeModal(e) {
      this.QRSizeModal.title = this.$t('students.modal_download_qr.qr_download')
      this.QRSizeModal.value = true
      this.QRSizeModal.student = e
    },
    showQrSizeModalAll() {
      this.allQrs = true
      this.QRSizeModal.title = this.$t('students.modal_download_qr.qr_download')
      this.QRSizeModal.value = true
      this.QRSizeModal.student = []
    },
    /* 		importStudents() {
			for (const [index, item] of this.students.entries()) {
				this.matriculas[String(item.personId)] = 1;
			}
			this.modals.import = true;
		}, */
    importStudentsAndParents() {
      for (const [index, item] of this.students.entries()) {
        this.matriculas[String(item.personId)] = 1
      }
      this.modals.importParents = true
    },
    imported(items) {
      this.headers[3].filterItems = []
      this.headers[4].filterItems = []
      this.headers[5].filterItems = []
      this.headers[6].filterItems = []
      this.filters.search = ''
      this.filters.levelIds = []
      this.filters.gender = []
      this.filters.gradeGroupIds = []
      this.filters.parents = []
      this.getStudentsOfBranch()
    },
    importedStdsParents(items) {
      this.headers[3].filterItems = []
      this.headers[4].filterItems = []
      this.headers[5].filterItems = []
      this.headers[6].filterItems = []
      this.filters.search = ''
      this.filters.levelIds = []
      this.filters.gender = []
      this.filters.gradeGroupIds = []
      this.filters.parents = []
      this.getStudentsOfBranch()

      this.$forceUpdate()
    },
    stepProgress(obj) {
      this.superLoading.value = obj.value
      this.superLoading.total = obj.total
      this.superLoading.show = true
      if (this.superLoading.value == this.superLoading.total) {
        setTimeout(1000)
        this.superLoading.show = false
      }
      this.$forceUpdate()
    },
    clearSearch() {
      this.filters.search = ''
      this.getStudentsOfBranch()
    },
    removeFilters() {
      this.filters.levelIds = []
      this.filters.gradeGroupIds = []
      this._resetGgs()
      this._resetLevels()
      this.headers[5].filterItems = []
      this.headers[6].filterItems = []
      this.filters.search = ''
      this.filters.gender = []
      this.filters.parents = []
      this.selected = []
      this.filters.qrEnabled = null
      this.qrArray = []
      this.getStudentsOfBranch()
    },
    expandWorshop(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
          workshop: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.workshop) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
          workshop: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.workshop) {
        props.expanded = !props.expanded

        this.expandables = {
          extras: false,
          parents: false,
          workshop: true,
        }
      } else if (props.expanded && !this.expandables.workshop) {
        this.expandables = {
          extras: false,
          parents: false,
          workshop: true,
        }
      }
    },
    expandExtras(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.extras) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.extras) {
        props.expanded = !props.expanded

        this.expandables = {
          extras: true,
          parents: false,
        }
      } else if (props.expanded && !this.expandables.extras) {
        this.expandables = {
          extras: true,
          parents: false,
        }
      }
    },
    expandParents(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.parents) {
        props.expanded = !props.expanded
        this.expandables = {
          extras: false,
          parents: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.parents) {
        props.expanded = !props.expanded

        this.expandables = {
          extras: false,
          parents: true,
        }
      } else if (props.expanded && !this.expandables.parents) {
        this.expandables = {
          extras: false,
          parents: true,
        }
      }
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.importParents = false
      this.QRSizeModal.value = false
      this.QRSizeModal.student = []
      this.modals.student = false
      this.modals.import = false
      this.modals.notify = false
      this.modals.student_v2 = false
      this.desblockQR = false
      this.blockQR = false
      this.$forceUpdate()
    },
    onUpdateQR() {
      this.modals.importParents = false
      this.QRSizeModal.value = false
      this.QRSizeModal.student = []
      this.modals.student = false
      this.modals.import = false
      this.modals.notify = false
      this.desblockQR = false
      this.blockQR = false
      this.$forceUpdate()
    },
    getAvatar(obj) {
      return obj.imageStorage && obj.imageStorage.miniObjUrl
        ? obj.imageStorage.miniObjUrl
        : undefined
    },
    async getBirthDateStudents(isLoadMore = false, clear = false) {
      if (clear) {
        this.birthDate.students = []
        this.birthDate.offset = 0
      }
      const params = {
        search:
          this.birthDate.search === '' ? undefined : this.birthDate.search,
        months: this.birthDate.selectedMonths,
        size: 15,
        offset: this.birthDate.offset,
      }

      if (isLoadMore) {
        this.birthDate.loadingMore = true
      } else {
        this.birthDate.isLoading = true
      }
      try {
        const { data } = await this.$store.dispatch(
          'student/getStudentsBirthdates',
          params
        )

        this.birthDate.students = [...this.birthDate.students, ...data.data]
        this.birthDate.totalStudents = data.total
      } catch (err) {
        console.log(err)
        this.birthDate.students = []
        this.birthDate.totalStudents = 0
      } finally {
        this.birthDate.isLoading = false
        this.birthDate.loadingMore = false
      }
    },
    getCurrentMonth(getMonthNumber = false) {
      return new Date(Date.now()).getMonth() + (getMonthNumber ? 1 : 0)
    },
    createMonths() {
      let a = []
      let temp
      for (let i = 1; i <= 12; i++) {
        a.push({
          long: this.createMonth(i),
          short: this.createMonth(i, 'short'),
        })
      }
      temp = a[0]
      a[a.length] = temp
      a.splice(0, 1)
      return a.map((e, i) => ({ value: i + 1, name: e.long, short: e.short }))
    },
    createMonth(monthNumber, monthFormat = 'long') {
      let a = new Intl.DateTimeFormat('es-MX', {
        month: monthFormat,
      }).format(new Date(`2022-${monthNumber.toString().padStart(2, '0')}-01`))

      return a.charAt(0).toUpperCase() + a.slice(1)
    },
    parseBirhDate(date) {
      const a = new Intl.DateTimeFormat('es-MX', {
        day: 'numeric',
        month: 'short',
      }).format(new Date(date))
      let [day, month] = a.split(' ')
      return `${day} ${month.charAt(0).toUpperCase() + month.slice(1)}`
    },
    async handleScroll() {
      const event = document.getElementById('birthdateStudentsSidePanel')
      if (
        event.offsetHeight + event.scrollTop >= event.scrollHeight &&
        !this.isLoading
      ) {
        if (this.birthDate.students.length + 1 < this.birthDate.totalStudents) {
          this.birthDate.offset = this.birthDate.students.length
          await this.getBirthDateStudents(true)
        }
      }
    },
    toggleMonths() {
      if (this.birthDate.selectedMonths.length)
        this.birthDate.selectedMonths = []
      else
        this.birthDate.selectedMonths = this.birthDate.allMonths
          .map((e) => e.value)
          .slice()
    },
    downloadBirthDateXlsx() {
      const params = {
        search:
          this.birthDate.search === '' ? undefined : this.birthDate.search,
        months: this.birthDate.selectedMonths,
      }

      this.working.wLoading = true
      this.$store
        .dispatch('student/getStudentsBirthdatesXlsx', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((error) => {
          console.log(error)
          this.toast.failed = true
        })
        .finally(() => {
          this.working.wLoading = false
        })
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  computed: {
    ...mapGetters(['getBranch', 'getUser', 'getLang']),
    filtersRemove() {
      if (
        this.filters.levelIds.length > 0 ||
        this.filters.search > 0 ||
        this.filters.gradeGroupIds.length > 0 ||
        this.filters.gender.length > 0 ||
        this.filters.parents.length > 0 ||
        this.qrArray.length > 0
      ) {
        return true
      } else {
        return false
      }
    },
    selectAllMonths() {
      return (
        this.birthDate.selectedMonths.length === this.birthDate.allMonths.length
      )
    },
    selectSomeMonths() {
      return this.birthDate.selectedMonths.length > 0 && !this.selectAllMonths
    },
    iconBirthdate() {
      if (this.selectAllMonths) return 'disabled_by_default'
      if (this.selectSomeMonths) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}

.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
  margin-bottom: 0;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.fitty {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.no-border {
  border: 0;
}

.widthNivel {
  width: 140px !important;
}
.widthCode {
  width: 200px !important;
}
.widthPersonId {
  width: 80px !important;
}
.widthGG {
  width: 100px !important;
}

.widthTutors {
  width: 100px !important;
}
.widthGender {
  width: 100px !important;
}
.widthLastName {
  width: 130px !important;
}
.widthFirstName {
  width: 130px !important;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.little-green {
  background-color: #e5ecdf !important;
}
</style>

<style scoped>
.sortable_pick {
  cursor: pointer;
}
.sort_arrow {
  display: inline-block;
  width: 10px;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(90%);
}
.main-tool-bar {
  z-index: 1;
}

::v-deep .main-tool-bar .v-toolbar__content {
  height: auto !important;
}

::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
}

.scroller {
  height: 100%;
}

::v-deep
  .custom_input
  .v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  border-radius: 6px;
  border: 2px solid #d1d5db;
}
.card {
  border: 1px solid #d1d5db;
  border-radius: 6px;
}
</style>
